<div class="file-manager-nav">
    <button
        class="back-button"
        *ngIf="path.length"
        (click)="backFolder(path.length - 2)">
        <i class="fa fa-arrow-left"></i>
    </button>
    <div class="back-path">
        <button class="back-folder-home" (click)="backFolder(-1)">
            <i class="fa fa-home"></i>
        </button>
        <button
            class="back-folder"
            *ngFor="let folder of path; let i = index"
            (click)="backFolder(i)">
            {{ folder }}
        </button>
    </div>
</div>
<div class="file-manager-loading" *ngIf="updatingPath">
    <app-loader></app-loader>
</div>
<div class="w-100" *ngIf="!updatingPath">
    <div class="file-manager" *ngIf="!isPathFile">
        <div
            class="file"
            [class.is-folder]="file.isFolder"
            [class.has-thumb]="tieneMiniatura(file)"
            [attr.data-file-ext]="file.extension"
            (click)="fileClicked(file)"
            *ngFor="let file of files; trackBy: trackFile">
            <div class="file-content">
                <div class="file-icon">
                    <!--
                        La miniatura es lo que el operario mira para encontrar
                        la foto: `loading="lazy"` deja que el navegador se traiga
                        solo las de la parte visible, que en una carpeta con
                        cientos de fotos es la diferencia entre abrirla y no.
                    -->
                    <img
                        *ngIf="tieneMiniatura(file)"
                        class="file-thumb"
                        [src]="urlMiniatura(file)"
                        [alt]="file.name"
                        loading="lazy"
                        decoding="async"
                        (error)="miniaturaFallida(file)" />
                    <svg
                        *ngIf="file.isFolder"
                        xmlns="http://www.w3.org/2000/svg"
                        height="1em"
                        viewBox="0 0 512 512">
                        <path
                            d="M464 128H272l-64-64H48C21.49 64 0 85.49 0 112v288c0 26.51 21.49 48 48 48h416c26.51 0 48-21.49 48-48V176c0-26.51-21.49-48-48-48z" />
                    </svg>
                    <svg
                        *ngIf="!file.isFolder && !tieneMiniatura(file)"
                        xmlns="http://www.w3.org/2000/svg"
                        height="1em"
                        viewBox="0 0 384 512">
                        <path
                            d="M0 64C0 28.7 28.7 0 64 0H224V128c0 17.7 14.3 32 32 32H384V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zm384 64H256V0L384 128z" />
                    </svg>
                </div>
                <div class="file-info">
                    <div class="file-title">{{ file.name }}</div>
                    <div class="file-subtitle" *ngIf="file.description?.length">
                        {{ file.description }}
                    </div>
                </div>
                <!--
                    Un enlace, no un botón: el backend responde con
                    `Content-Disposition: attachment`, así que el navegador
                    guarda el fichero sin salir de la aplicación. Un `<a>` dentro
                    de un `<button>` sería marcado inválido.

                    `target="_blank"` es el seguro para cuando la respuesta NO
                    es el fichero: si la firma ha caducado porque otro operario
                    sustituyó la foto, o el montaje de red está caído, llega un
                    403/404/503, y sin esto el navegador navegaría a esa página
                    de error sacando al operario de la aplicación a media OF.
                    Cuando sí es el fichero, la pestaña se cierra sola.

                    `stopPropagation` para que descargar no cuente además como
                    abrir la foto.
                -->
                <a
                    class="file-download"
                    *ngIf="!file.isFolder && file.firma"
                    [href]="urlDescarga(file)"
                    [attr.download]="file.name"
                    target="_blank"
                    rel="noopener"
                    (click)="$event.stopPropagation()"
                    [attr.aria-label]="'Descargar ' + file.name">
                    <i class="fa fa-download"></i>
                </a>
            </div>
        </div>
        <div class="file-add" (click)="openCapCaptureModal()">
            <div class="file-content">
                <div class="file-icon">
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        height="1em"
                        viewBox="0 0 512 512">
                        <!--! Font Awesome Free 6.4.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc. -->
                        <path
                            d="M512 144v288c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V144c0-26.5 21.5-48 48-48h88l12.3-32.9c7-18.7 24.9-31.1 44.9-31.1h125.5c20 0 37.9 12.4 44.9 31.1L376 96h88c26.5 0 48 21.5 48 48zM376 288c0-66.2-53.8-120-120-120s-120 53.8-120 120 53.8 120 120 120 120-53.8 120-120zm-32 0c0 48.5-39.5 88-88 88s-88-39.5-88-88 39.5-88 88-88 88 39.5 88 88z" />
                    </svg>
                </div>
                <div class="file-title">Capturar imagen</div>
            </div>
        </div>
    </div>
    <div class="file-preview" *ngIf="isPathFile">
        <div *ngIf="!isImage(pathFile)">
            <ngx-doc-viewer
                [hidden]="isPDFLoaded"
                [url]="getServeFile(pathFile)"
                viewer="google"
                (loaded)="pdfLoaded()"
                style="width: 100%; height: 50vh"></ngx-doc-viewer>
            <div class="file-preview-loading" *ngIf="!isPDFLoaded">
                <app-loader></app-loader>
            </div>
            <div class="file-preview-acciones" *ngIf="pathFile?.firma">
                <a
                    class="btn btn-primary"
                    [href]="urlDescarga(pathFile)"
                    [attr.download]="pathFile.name"
                    target="_blank"
                    rel="noopener">
                    <i class="fa fa-download"></i> Descargar
                </a>
            </div>
        </div>
        <div *ngIf="isImage(pathFile)">
            <img
                [src]="getServeFile(pathFile)"
                class="w-100 img-preview"
                alt="file-preview" />
            <div class="file-preview-acciones" *ngIf="pathFile?.firma">
                <button
                    type="button"
                    class="btn btn-primary"
                    (click)="abrirVisor(pathFile)">
                    <i class="fa fa-search-plus"></i> Ampliar
                </button>
                <a
                    class="btn btn-secondary"
                    [href]="urlDescarga(pathFile)"
                    [attr.download]="pathFile.name"
                    target="_blank"
                    rel="noopener">
                    <i class="fa fa-download"></i> Descargar
                </a>
            </div>
            <p *ngIf="pathFile?.description?.length" class="form-control mt-2">
                <strong>Descripción:</strong> {{ pathFile.description ? pathFile.description : '' }}
            </p>
        </div>
    </div>
</div>

<app-camera-capture-modal
    #camCaptureModal
    (imageUploaded)="updateFiles()"
    [article_id]="article_id"
    [path]="path">
</app-camera-capture-modal>

<app-image-viewer #visor></app-image-viewer>
